export const errorValidation = (validation, target) => {
  // if(!validDate) or if(!target.checked) or if(!value.checked)
  if (!validation) {
    setFieldError(target);
    return false;
  } else {
    removeFieldError(target);
    return true;
  }
};

export const setFieldError = (target) => {
  target.closest("fieldset").classList.add("is--error");
  scrollToFirstError();
};

export const removeFieldError = (target) => {
  const component = target.closest("fieldset");

  if (component.classList.contains("is--error")) {
    component.classList.remove("is--error");
  }
};

export const scrollToFirstError = () => {
  console.log("scrolling to the error");
};
